<template>
  <div id="app">    
    <calculator v-if="showCalculator"></calculator>
    <div v-if="!showCalculator" class="section has-text-centered">
      <div class="container">
        <h1 class="title">
          <a href="https://martyleeds33.com/">martyleeds33.com</a>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import Calculator from "./components/Calculator";

export default {
  name: "app",
  data() {
    return {
      showCalculator: true,
      environment: process.env.NODE_ENV,
      hostName: window.location.hostname
    };
  },
  methods: {
    canShowCalculator: function() {
      // must be show in iframe only on MartyLeeds
      if (
        process.env.NODE_ENV === "development" ||
        (!window === window.parent &&
          window.location.hostname === "martyleeds33.com")
      ) {
        this.showCalculator = true;
      }      
    }
  },
  components: {
    Calculator
  },
  mounted() {
    this.canShowCalculator();
  }
};
</script>

<style>
</style>
